import axios from 'axios';

let api = null;

export function createApi() {
  api = axios.create({
    baseURL: `${process.env.VUE_APP_HOST_API_BACKEND}` || 'http://localhost:3030/api/',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  return api;
}

export function useApi() {
  if (!api) {
    createApi();
  }
  return api;
}
